<template>
  <div class="attachable-category-template-placeholder">
    <div v-if="!hasAttachableCategory" style="padding: 8px 10px;">
      <a-button class="pull-right create-category-and-upload-button" type="default" v-on:click="onClick">
        <upload-icon></upload-icon>
        Uploaden
      </a-button>
      <div style="padding: 5px 0;">
        Er staan nog geen documenten in deze map
      </div>
    </div>
    <AttachableCategoryPaginatedCategoryOverviewComponent
        v-if="hasAttachableCategory"
        ref="attachableCategoryPaginatedOverview"
        v-bind:attachable-category="attachableCategory"
        v-bind:customer-id="customerId"
        v-bind:has-attachable-type="hasAttachableType"
        v-bind:has-attachable-id="hasAttachableId"
        v-bind:publish-documents="publishDocuments"
        v-on:count-updated="onAttachableCategoryCountUpdated"
    ></AttachableCategoryPaginatedCategoryOverviewComponent>
  </div>
</template>

<script>
import AttachableCategoryPaginatedCategoryOverviewComponent from './PaginatedOverviewComponent'
import attachableCategoryApi from '~/api/attachable_category'

export default {
  name: 'AttachableCategoryTemplatePlaceholderComponent',
  props: {
    attachableCategoryTemplateId: {
      type: [Number, String],
      required: true,
    },
    customerId: {
      type: [String, Number],
      default: null,
    },
    hasAttachableType: {
      type: String,
      default: null,
    },
    hasAttachableId: {
      type: [String, Number],
      default: null,
    },
    publishDocuments: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AttachableCategoryPaginatedCategoryOverviewComponent
  },
  data () {
    return {
      attachableCategory: null,
      hasAttachableValue: null,
    }
  },
  created () {
    if (this.hasAttachableId === null || this.hasAttachableType === null) {
      throw new Error('The has attachable must be provided')
    }
  },
  computed: {
    hasAttachableCategory () {
      return this.attachableCategory !== null
    },
  },
  methods: {
    onClick () {
      this.$nextTick(async () => {
        await attachableCategoryApi
            .createFromTemplate(this.hasAttachableType, this.hasAttachableId, this.attachableCategoryTemplateId).then(response => {
              this.attachableCategory = response.data

              this.$nextTick(async () => {
                await setTimeout(async () => {
                  await this.$refs.attachableCategoryPaginatedOverview.onUploadClick()
                }, 500)
              })
            })
      })
    },
    onAttachableCategoryCountUpdated (attachableCategoryId, count) {
      this.$emit('count-updated', this.attachableCategoryTemplateId, count)
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>